import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  cart: [],
  cartTotal:{}
};

const cartdetailsSlice = createSlice({
  name: "storeList",
  initialState,
  reducers: {
    setCart: (state, action) => {
      state.cart = action.payload;
    },
    setTotal: (state, action) => {
      state.cartTotal = action.payload;
    },
    clearCart: (state) => {
      state.storeList = [];
    },
  },
});


export const { setCart, setTotal,clearCart } = cartdetailsSlice.actions;


export default cartdetailsSlice.reducer;
